import { useSelector } from "react-redux";
import { selectTicketTypeById } from "store/modules/workspace/workspace.selectors";

export const TicketIcon = ({ ticketTypeId }: { ticketTypeId: string }) => {
  const ticketType = useSelector(selectTicketTypeById(ticketTypeId!));
  return <>{ticketType?.emoji}</>;
};
